module.exports = __webpack_public_path__ + "img/placeholder.f395a148.png";